import { Collapsible } from 'radix-ui'

import Icon from '@/legacy-src/components/icons/Icon'
import type { TherapistType } from '@/legacy-src/types/TherapistStateType'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import { Text } from '@/src/domains/design-system/components/Text'

export interface RecommendedTherapistProfileBioSessionRolldownUIProps {
  open: boolean
  office: NonNullable<TherapistType['office']>
}

export const RecommendedTherapistProfileBioSessionRolldownUI = ({
  open,
  office,
}: RecommendedTherapistProfileBioSessionRolldownUIProps) => {
  const { t } = getTranslate()

  return (
    <>
      <Collapsible.Content className="block overflow-hidden data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down">
        <div className="block pb-5 pt-3">
          <Text element="h5" variant="sm" weight="bold" className="mb-2">
            {t('component.therapistProfile.session.offline.officeAmenities')}
          </Text>
          <Text asChild variant="sm" className="m-0 flex list-none flex-col gap-2 p-0">
            <ul>
              {office.wheelchairAccessible ? (
                <li>
                  <Icon icon="disability" size={16} className="mr-1" />
                  {t('component.therapistOffice.wheelchairAccessible')}
                </li>
              ) : null}
              {office.freeParking ? (
                <li>
                  <Icon icon="parking" size={16} className="mr-1" />
                  {t('component.therapistOffice.freeParking')}
                </li>
              ) : null}
              {office.paidParkingNearby ? (
                <li>
                  <Icon icon="paid-parking" size={16} className="mr-1" />
                  {t('component.therapistOffice.paidParkingNearby')}
                </li>
              ) : null}
              {office.waitingAreaAvailable ? (
                <li>
                  <Icon icon="waiting-area" size={16} className="mr-1" />
                  {t('component.therapistOffice.waitingAreaAvailable')}
                </li>
              ) : null}
            </ul>
          </Text>
        </div>
      </Collapsible.Content>
      <Text
        asChild
        variant="sm"
        className="group m-0 flex items-center gap-1 border-none bg-transparent p-0 text-primary"
      >
        <Collapsible.Trigger>
          {open ? t('general.lessInformation') : t('general.moreInformation')}
          <Icon icon="arrows-beak" className="transition-transform duration-500 group-data-[state=open]:rotate-180" />
        </Collapsible.Trigger>
      </Text>
    </>
  )
}
